// extracted by mini-css-extract-plugin
export default {"eventPost":"EventPost_eventPost__zYiXh","backButton":"EventPost_backButton__vzJRJ","eventPost__timeWrapper":"EventPost_eventPost__timeWrapper__MdZpp"};